import React, { useEffect } from 'react'
import styled from 'styled-components'
import Flex from 'components/Flex'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getCorporateLandingPath } from 'utils/corporateLanding'

export const Wrapper = styled(Flex)`
  height: 100vh;
  width: 100%;
  background-color: #f6f6f6;
`

const SignInCard = styled.div`
  background-color: white;
  padding: 40px 32px;
  border-radius: 3px;
  max-width: 450px;
  width: 100%;
  margin: auto;
  box-shadow: 0px 2px 10px rgba(99, 116, 135, 0.2);
`
const { AUTH_URL } = process.env

const UserSignin = ({ token, SignIn, corporateDetails }) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    let active = true
    const urlToken = searchParams.get('token')
    const signInAndRedirect = async () => {
      if (!urlToken && !token) {
        window.open(AUTH_URL, '_self')
        return
      }

      let corporate
      try {
        corporate = urlToken ? await SignIn(urlToken) : await corporateDetails()
      } catch {
        console.error('Unable to resolve corporate landing page')
      }
      if (!active) {
        return
      }

      const path = getCorporateLandingPath(corporate?.accessLevel)
      if (path.startsWith('/v2/')) {
        // v2 reads this token directly; do not race redux-persist's async write.
        localStorage.setItem('token', urlToken || token)
        window.location.replace(path)
      } else {
        navigate(path, { replace: true })
      }
    }
    signInAndRedirect()
    return () => {
      active = false
    }
  }, [])

  return (
    <Wrapper column>
      <SignInCard>Loading...</SignInCard>
    </Wrapper>
  )
}
export default UserSignin
